import { HttpParams } from '@angular/common/http';

import { toHTTPParam } from '../../../../core';
import { periodicidadeDiaria } from '../integration-periodicidade';

export class IntegrationTituloReceber {
    periodicidade: number;
    dataInicialBase: Date;

    constructor() {
        this.periodicidade = periodicidadeDiaria.id;
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade
        if (this.periodicidade) {
            params = params.append('periodicidade', this.periodicidade.toString());
        }
        // Data Inicial Base
        if (this.dataInicialBase) {
            params = params.append('dataInicialBase', toHTTPParam(this.dataInicialBase));
        }
        // Execução manual
        params = params.append('manual', 'true');
        // Atualizar os clientes antes
        params = params.append('atualizarClientes', 'true');

        return params;
    }

    clear() {
        this.periodicidade = periodicidadeDiaria.id;
        this.dataInicialBase = null;
    }
}
